import './index.css'

const HistoryItem = props => {
  const {historyDetails, onClickDelete} = props
  const {timeAccessed, logoUrl, title, domainUrl, id} = historyDetails
  const onDelete = () => onClickDelete(id)

  return (
    <li className="history-item">
      <div className="history-item-container">
        <p className="time-accessed">{timeAccessed}</p>
        <img src={logoUrl} alt="domain logo" className="app-logo" />
        <div className="app-details-container">
          <p className="domain-name">{title}</p>
          <p className="domain-url">{domainUrl}</p>
        </div>
      </div>
      <button
        type="button"
        className="delete-button"
        onClick={onDelete}
        data-testid="delete"
      >
        <img
          src="https://assets.ccbp.in/frontend/react-js/delete-img.png"
          alt="delete"
          className="delete-logo"
        />
      </button>
    </li>
  )
}

export default HistoryItem
